import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
import screenfull from 'screenfull';
import { FullScreenOne, OffScreenOne } from '@icon-park/vue-next';
import { toast } from '@/utils/message';

import { ref, onMounted, onBeforeUnmount } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'ScreenFull',
  setup: function setup(__props) {
    var isFullscreen = ref(false);
    onMounted(function () {
      init();
    });
    onBeforeUnmount(function () {
      if (screenfull.isEnabled) {
        screenfull.off('change', change);
      }
    });
    function click() {
      if (!screenfull.isEnabled) {
        toast.warn('你的浏览器不支持该功能');
        return false;
      }
      screenfull.toggle();
    }
    function change() {
      isFullscreen.value = screenfull.isFullscreen;
    }
    function init() {
      if (screenfull.isEnabled) {
        screenfull.on('change', change);
      }
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", null, [_unref(isFullscreen) ? (_openBlock(), _createBlock(_unref(OffScreenOne), {
        key: 0,
        theme: "outline",
        size: "20",
        fill: "#666666",
        onClick: click
      })) : (_openBlock(), _createBlock(_unref(FullScreenOne), {
        key: 1,
        theme: "outline",
        size: "20",
        fill: "#666666",
        onClick: click
      }))]);
    };
  }
});